export default {
    LOAD_CONTRACT_EXPIRATION(state, contract_expiration) {
        state.items = contract_expiration;
    }
}